Base = App.loadClass('core::reports/BaseOutput')

class exports.DetailOutput extends Base
    constructor: (parent, dialog, width = 'auto', dtOpts = {}, auxOpts = {}) ->
        # include default pagination attributes
        defOpts =
            bPaginate: true
            bServerSide: true
            bProcessing: true
            iDisplayLength: 50
            fnServerParams: (aoData) =>
                aoData.push({ name: 'query', value: ko.toJSON(@parent.filters) })
            fnInitComplete: () ->
                @fnAdjustColumnSizing(false)
            sDom: "<'row-fluid'<'span8'l>r>t<'row-fluid'<'span8'p>>"
            bScrollCollapse: true
            sPaginationType: 'bootstrap'

        dtOpts = $.extend defOpts, dtOpts

        super(parent, dialog, width, dtOpts, auxOpts)
